// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media screen and (max-width: 768px) {\n.dCardList[data-v-eeffa33e] {\n    display: block;\n}\n.dTable[data-v-eeffa33e] {\n    display: none;\n}\n}\n@media screen and (min-width: 768px) {\n.dCardList[data-v-eeffa33e] {\n    display: none;\n}\n.dTable[data-v-eeffa33e] {\n    display: block;\n}\n}\n", ""]);
// Exports
module.exports = exports;
